import { createSlice } from "@reduxjs/toolkit";

export const relatedContactListSlice = createSlice({
  name: "relatedContactList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedRelatedContact: null,
    filteredRecords: 0,
    isSingleRelatedContactLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
  },
  reducers: {
    setAllRelatedContactLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleRelatedContactLoadingState: (state, action) => {
      state.isSingleRelatedContactLoading = true;
    },
    loadAllRelatedContact: (state, action) => {
      const listObj = {};
      action.payload.relatedContacts.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.relatedContacts.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleRelatedContact: (state, action) => {
      state.selectedRelatedContact =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleRelatedContactLoading = false;
    },
  },
});

export const {
  setAllRelatedContactLoadingState,
  setSingleRelatedContactLoadingState,
  loadAllRelatedContact,
  loadSingleRelatedContact,
} = relatedContactListSlice.actions;

export default relatedContactListSlice.reducer;
